import { ButtonColor } from "@/common/enum/button-color";
import { userService } from "@/services/user-service";
import { UserDto } from "@/types/dto/user-dto";
import { Button, Modal } from "flowbite-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { profileState } from "../../atoms/user/profile-state";
import { PartnerInfoTable } from "../table/partner-info-table/PartnerInfoTable";
import { H4 } from "../typography/H4";

interface Props {
  closeModal: () => void;
  userId?: number;
}

export const PartnerInfoModal: React.FC<Props> = ({ closeModal, userId }) => {
  const [profile, setProfile] = useRecoilState(profileState);
  const [partner, setPartner] = useState<UserDto | undefined>();
  const navigate = useNavigate();
  const user = userId ? partner! : profile!;

  const onClick = () => {
    window.open(`/partner/detail/${user.id}`, "_blank");
  };

  const getUser = async () => {
    if (!userId) {
      return;
    }

    try {
      const response = await userService.getPartnerById(userId);
      if (response.ok) {
        setPartner(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, [userId]);

  return (
    <Modal size="4xl" show={true} onClose={closeModal}>
      <Modal.Header className="p-[24px] h-[76px]">
        <H4>파트너 정보</H4>
      </Modal.Header>
      <Modal.Body>
        <div className="flex justify-center">
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col">
              {user && <PartnerInfoTable user={user} />}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button color={ButtonColor.PRIMARY} onClick={onClick}>
            자세히 보기
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
